import { WorkingHour } from './working-hour';
import { WorkingHourProof } from './working-hour-proof';

export class WorkingDayOrder {

  constructor(
    public hash?: string,
    public userHash?: string,
    public userName?: string,
    public userLastName?: string,
    public userReference?: number,
    public userRole?: string,
    public userWorkingShiftHash?: string,
    public workingShiftHash?: string,
    public workingShiftName?: string,
    public workingShiftHasBreak?: boolean,
    public workingShiftBreakTime?: number,
    public information?: string,
    public date?: number,
    public totalItem?: number,
    public extraTime?: number,
    public workingHours?: WorkingHour[],
    public workingHourProofs?: WorkingHourProof[]
  ) { }

  clone() {
    return new WorkingDayOrder(
      this.hash,
      this.userHash,
      this.userName,
      this.userLastName,
      this.userReference,
      this.userRole,
      this.userWorkingShiftHash,
      this.workingShiftHash,
      this.workingShiftName,
      this.workingShiftHasBreak,
      this.workingShiftBreakTime,
      this.information,
      this.date,
      this.totalItem,
      this.extraTime,
      this.workingHours,
      this.workingHourProofs
    );
  }

  get userLastNameAndName() {
    return (this.userLastName && this.userName) ? `${this.userLastName}, ${this.userName}` : this.userName ?
       this.userName : this.userLastName ? this.userLastName : '';
  }

}




// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/working-day-order.ts